var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g, _path45, _g2, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagedServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 466,
    viewBox: "0 0 257 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7953 464.971H204.205C233.086 464.971 256.5 441.82 256.5 413.263L256.5 52.6787C256.5 24.1212 233.086 0.970795 204.205 0.970795H52.7953C23.9134 0.970795 0.5 24.1212 0.5 52.6787L0.5 413.263C0.5 441.82 23.9134 464.971 52.7953 464.971Z",
    fill: "url(#paint0_linear_157_1102)",
    stroke: "url(#paint1_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0969 408.814V284.983C20.0496 277.287 29.8313 270.589 40.2654 265.009C119.762 222.582 201.313 266.297 234.906 225.708C238.94 220.799 244.1 212.515 246.061 198.819V94.5655C246.063 90.848 245.596 87.1448 244.671 83.5416C245.64 87.2245 246.129 91.0147 246.127 94.8202V408.814C246.127 420.662 241.367 432.025 232.894 440.402C224.421 448.78 212.929 453.487 200.946 453.487H56.2769C50.3438 453.487 44.4689 452.331 38.9874 450.086C33.5059 447.841 28.5252 444.551 24.3298 440.402C20.1344 436.254 16.8065 431.329 14.536 425.91C12.2655 420.49 11.0969 414.681 11.0969 408.814Z",
    fill: "url(#paint2_linear_157_1102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.809 171.242H224.455V419.85C224.455 423.584 222.955 427.165 220.284 429.806C217.614 432.446 213.992 433.93 210.215 433.93H156.809V171.242Z",
    fill: "#151529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.095 427.726V404.973H163.083V427.726H186.095Z",
    fill: "#28294B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.361 398.766C170.516 398.766 171.452 397.84 171.452 396.698C171.452 395.556 170.516 394.63 169.361 394.63C168.206 394.63 167.269 395.556 167.269 396.698C167.269 397.84 168.206 398.766 169.361 398.766Z",
    fill: "#28294B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.654 433.93V332.947C145.654 329.737 144.364 326.658 142.068 324.388C139.772 322.119 136.659 320.843 133.412 320.843H43.5359C40.2893 320.843 37.1756 322.119 34.8799 324.388C32.5842 326.658 31.2944 329.737 31.2944 332.947V421.814C31.2944 425.024 32.5842 428.103 34.8799 430.373C37.1756 432.643 40.2893 433.918 43.5359 433.918L145.654 433.93Z",
    fill: "url(#paint3_linear_157_1102)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.361 396.007V268.457",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.361 396.698V274.661",
    stroke: "url(#paint4_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.821 396.007V330.164",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M203.528 417.383V351.537",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.821 398.766C180.976 398.766 181.912 397.84 181.912 396.698C181.912 395.556 180.976 394.63 179.821 394.63C178.666 394.63 177.729 395.556 177.729 396.698C177.729 397.84 178.666 398.766 179.821 398.766Z",
    fill: "#28294B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.94 416.865H204.574",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.775 329.993H192.022",
    stroke: "#28294B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.245 418.933C194.4 418.933 195.336 418.007 195.336 416.865C195.336 415.723 194.4 414.797 193.245 414.797C192.09 414.797 191.153 415.723 191.153 416.865C191.153 418.007 192.09 418.933 193.245 418.933Z",
    fill: "#28294B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.732 399.112V259.839H190.629V399.112H215.732Z",
    fill: "url(#paint5_linear_157_1102)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.653 309.132V266.386H18.7426V309.132H145.653Z",
    fill: "#151529"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.681 302.238V291.208H127.526V302.238H138.681Z",
    fill: "#28294B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231.421 236.696C235.654 231.329 242.852 221.057 246.523 203.63L246.064 61.601C246.064 34.7207 225.836 12.9367 200.884 12.9367H56.2117C52.0556 12.9696 47.9272 13.6106 43.961 14.839C36.4292 17.2085 29.6441 21.4613 24.2629 27.1853C11.9408 40.3785 11.1248 57.4958 11.0317 61.5857C11.0442 148.487 11.0576 235.387 11.072 322.285C13.3869 317.109 18.5193 306.757 27.8098 296.758C82.5131 237.904 186.924 293.122 231.421 236.696Z",
    fill: "url(#paint6_linear_157_1102)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.064 205.161V199.905C244.305 209.604 240.358 223.579 230.276 235.591C211.481 257.989 182.316 263.545 134.234 264.297C66.666 265.355 44.6157 275.582 26.7205 295.592C18.3144 304.99 13.6879 315.1 11.072 322.285V323.037C15.366 313.579 21.1459 304.851 28.1976 297.178C28.1976 297.178 34.5402 290.057 42.3443 284.74C59.1317 273.308 83.6146 267.337 134.265 266.543C182.216 265.791 212.999 260.406 231.871 237.042C240.749 226.058 244.395 213.693 246.064 205.161Z",
    fill: "url(#paint7_linear_157_1102)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.361 397.732C169.938 397.732 170.406 397.269 170.406 396.698C170.406 396.127 169.938 395.664 169.361 395.664C168.783 395.664 168.315 396.127 168.315 396.698C168.315 397.269 168.783 397.732 169.361 397.732Z",
    fill: "#B0AAFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.821 397.732C180.399 397.732 180.867 397.269 180.867 396.698C180.867 396.127 180.399 395.664 179.821 395.664C179.243 395.664 178.775 396.127 178.775 396.698C178.775 397.269 179.243 397.732 179.821 397.732Z",
    fill: "#B0AAFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.245 417.899C193.822 417.899 194.29 417.436 194.29 416.865C194.29 416.294 193.822 415.831 193.245 415.831C192.667 415.831 192.199 416.294 192.199 416.865C192.199 417.436 192.667 417.899 193.245 417.899Z",
    fill: "#B0AAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.821 396.698V329.993H190.629",
    stroke: "url(#paint8_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.528 399.109V416.865H193.245",
    stroke: "url(#paint9_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M136.937 425.299V338.117C136.937 335.825 136.016 333.626 134.377 332.006C132.737 330.385 130.514 329.474 128.196 329.474H48.7582C46.4399 329.474 44.2166 330.385 42.5773 332.006C40.938 333.626 40.017 335.825 40.017 338.117V416.662C40.017 418.955 40.938 421.153 42.5773 422.774C44.2166 424.395 46.4399 425.305 48.7582 425.305L136.937 425.299Z",
    stroke: "url(#paint10_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0915 68.2063C58.3403 68.2063 67.4593 59.1898 67.4593 48.0673C67.4593 36.9448 58.3403 27.9282 47.0915 27.9282C35.8426 27.9282 26.7236 36.9448 26.7236 48.0673C26.7236 59.1898 35.8426 68.2063 47.0915 68.2063Z",
    fill: "#2F2B5E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M69.4213 377.555C74.1119 377.555 77.9143 373.795 77.9143 369.158C77.9143 364.52 74.1119 360.76 69.4213 360.76C64.7308 360.76 60.9283 364.52 60.9283 369.158C60.9283 373.795 64.7308 377.555 69.4213 377.555Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1057 394.881H89.1069C88.5309 394.881 87.9784 394.655 87.571 394.252C87.1637 393.85 86.9348 393.303 86.9348 392.734V392.525C86.9348 391.956 87.1637 391.409 87.571 391.006C87.9784 390.604 88.5309 390.377 89.1069 390.377H98.1057C105.314 390.377 111.328 384.717 111.449 377.592C111.474 375.87 111.153 374.16 110.505 372.561C109.856 370.963 108.893 369.508 107.671 368.28C106.449 367.053 104.993 366.077 103.386 365.411C101.78 364.745 100.056 364.401 98.3136 364.399H89.3986C88.8135 364.399 88.2524 364.169 87.8386 363.76C87.4248 363.351 87.1924 362.796 87.1924 362.218V359.898H98.3322C100.669 359.9 102.982 360.36 105.138 361.251C107.294 362.141 109.251 363.445 110.895 365.086C112.539 366.728 113.839 368.675 114.718 370.816C115.598 372.957 116.04 375.248 116.02 377.559C115.93 387.193 107.843 394.881 98.1057 394.881Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.58 378.97H78.9476C78.6484 378.97 78.3522 378.912 78.0757 378.799C77.7991 378.686 77.5478 378.52 77.3363 378.311C77.1247 378.102 76.9569 377.854 76.8426 377.58C76.7283 377.307 76.6696 377.014 76.67 376.718C76.67 376.422 76.729 376.13 76.8435 375.856C76.958 375.583 77.1258 375.335 77.3373 375.126C77.5489 374.918 77.7999 374.752 78.0763 374.639C78.3526 374.526 78.6487 374.468 78.9476 374.469H89.3057C89.9089 374.469 90.4874 374.706 90.914 375.128C91.3405 375.549 91.58 376.121 91.58 376.718V378.97Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0702 387.008H83.534C82.9304 387.008 82.3516 386.772 81.9246 386.35C81.4975 385.928 81.257 385.356 81.2562 384.76C81.2562 384.162 81.4962 383.589 81.9233 383.167C82.3505 382.745 82.9299 382.508 83.534 382.508H93.774C94.378 382.508 94.9573 382.745 95.3844 383.167C95.8115 383.589 96.0515 384.162 96.0515 384.76L96.0702 387.008Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2731 371.349H69.3283C68.7229 371.355 68.1387 371.128 67.7 370.716C67.2613 370.303 67.0028 369.738 66.9794 369.139C66.9732 368.84 67.0275 368.543 67.1391 368.265C67.2506 367.987 67.4172 367.734 67.6291 367.52C67.8409 367.307 68.0938 367.137 68.3728 367.022C68.6519 366.906 68.9514 366.847 69.2539 366.848H84.9956C85.5991 366.848 86.1779 367.084 86.605 367.506C87.032 367.928 87.2723 368.5 87.2731 369.096V371.349Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M69.3282 371.895C68.5753 371.901 67.8499 371.615 67.3072 371.099C66.7644 370.583 66.4473 369.877 66.4238 369.133C66.4168 368.761 66.4849 368.392 66.624 368.046C66.763 367.701 66.9703 367.386 67.2338 367.121C67.4973 366.855 67.8117 366.645 68.1585 366.501C68.5053 366.357 68.8777 366.283 69.2538 366.283H74.0387C73.4082 365.29 72.4667 364.528 71.3578 364.114C70.2488 363.699 69.0331 363.654 67.8959 363.986C66.7588 364.318 65.7626 365.008 65.059 365.951C64.3554 366.895 63.9829 368.04 63.9985 369.212C64.0141 370.384 64.4169 371.519 65.1453 372.444C65.8738 373.369 66.8881 374.033 68.0337 374.335C69.1793 374.637 70.3934 374.561 71.4909 374.118C72.5885 373.674 73.5094 372.888 74.1132 371.879L69.3282 371.895Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.756 87.4228H168.585C166.499 87.4228 164.808 89.0945 164.808 91.1568V121.16C164.808 123.223 166.499 124.894 168.585 124.894H220.756C222.842 124.894 224.532 123.223 224.532 121.16V91.1568C224.532 89.0945 222.842 87.4228 220.756 87.4228Z",
    fill: "#E3E5F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M220.756 87.4228H168.585C166.499 87.4228 164.808 89.0945 164.808 91.1568V121.16C164.808 123.223 166.499 124.894 168.585 124.894H220.756C222.842 124.894 224.532 123.223 224.532 121.16V91.1568C224.532 89.0945 222.842 87.4228 220.756 87.4228Z",
    stroke: "url(#paint11_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.179 87.4228H100.008C97.9222 87.4228 96.2314 89.0945 96.2314 91.1568V121.16C96.2314 123.223 97.9222 124.894 100.008 124.894H152.179C154.265 124.894 155.955 123.223 155.955 121.16V91.1568C155.955 89.0945 154.265 87.4228 152.179 87.4228Z",
    fill: "#E3E5F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.179 87.4228H100.008C97.9222 87.4228 96.2314 89.0945 96.2314 91.1568V121.16C96.2314 123.223 97.9222 124.894 100.008 124.894H152.179C154.265 124.894 155.955 123.223 155.955 121.16V91.1568C155.955 89.0945 154.265 87.4228 152.179 87.4228Z",
    stroke: "url(#paint12_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9816 87.4228H30.8103C28.7247 87.4228 27.0339 89.0945 27.0339 91.1568V121.16C27.0339 123.223 28.7247 124.894 30.8103 124.894H82.9816C85.0672 124.894 86.758 123.223 86.758 121.16V91.1568C86.758 89.0945 85.0672 87.4228 82.9816 87.4228Z",
    fill: "#E3E5F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9816 87.4228H30.8103C28.7247 87.4228 27.0339 89.0945 27.0339 91.1568V121.16C27.0339 123.223 28.7247 124.894 30.8103 124.894H82.9816C85.0672 124.894 86.758 123.223 86.758 121.16V91.1568C86.758 89.0945 85.0672 87.4228 82.9816 87.4228Z",
    stroke: "url(#paint13_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M220.446 134.979H168.275C166.189 134.979 164.498 136.651 164.498 138.713V168.717C164.498 170.779 166.189 172.451 168.275 172.451H220.446C222.531 172.451 224.222 170.779 224.222 168.717V138.713C224.222 136.651 222.531 134.979 220.446 134.979Z",
    fill: "#E3E5F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M220.446 134.979H168.275C166.189 134.979 164.498 136.651 164.498 138.713V168.717C164.498 170.779 166.189 172.451 168.275 172.451H220.446C222.531 172.451 224.222 170.779 224.222 168.717V138.713C224.222 136.651 222.531 134.979 220.446 134.979Z",
    stroke: "url(#paint14_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M151.869 134.979H99.6975C97.6119 134.979 95.9211 136.651 95.9211 138.713V168.717C95.9211 170.779 97.6119 172.451 99.6975 172.451H151.869C153.954 172.451 155.645 170.779 155.645 168.717V138.713C155.645 136.651 153.954 134.979 151.869 134.979Z",
    fill: "#E3E5F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M151.869 134.979H99.6975C97.6119 134.979 95.9211 136.651 95.9211 138.713V168.717C95.9211 170.779 97.6119 172.451 99.6975 172.451H151.869C153.954 172.451 155.645 170.779 155.645 168.717V138.713C155.645 136.651 153.954 134.979 151.869 134.979Z",
    stroke: "url(#paint15_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6713 134.979H30.5C28.4144 134.979 26.7236 136.651 26.7236 138.713V168.717C26.7236 170.779 28.4144 172.451 30.5 172.451H82.6713C84.7569 172.451 86.4477 170.779 86.4477 168.717V138.713C86.4477 136.651 84.7569 134.979 82.6713 134.979Z",
    fill: "#E3E5F0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6713 134.979H30.5C28.4144 134.979 26.7236 136.651 26.7236 138.713V168.717C26.7236 170.779 28.4144 172.451 30.5 172.451H82.6713C84.7569 172.451 86.4477 170.779 86.4477 168.717V138.713C86.4477 136.651 84.7569 134.979 82.6713 134.979Z",
    stroke: "url(#paint16_linear_157_1102)",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.464 109.397H195.302C196.585 109.397 197.816 108.893 198.723 107.996C199.63 107.099 200.14 105.882 200.14 104.614C200.14 103.345 199.63 102.129 198.723 101.231C197.816 100.334 196.585 99.8305 195.302 99.8305C194.019 99.8305 192.789 100.334 191.881 101.231C190.974 102.129 190.464 103.345 190.464 104.614V109.397Z",
    fill: "#7461F2"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M202.414 111.646H197.809C197.204 111.647 196.604 111.53 196.044 111.301C195.484 111.072 194.975 110.737 194.547 110.314C194.118 109.891 193.778 109.388 193.546 108.835C193.314 108.282 193.195 107.689 193.195 107.09C193.194 106.49 193.312 105.896 193.544 105.342C193.775 104.788 194.115 104.285 194.544 103.861C194.972 103.437 195.482 103.101 196.042 102.872C196.602 102.643 197.203 102.526 197.809 102.527C198.414 102.527 199.013 102.645 199.572 102.873C200.131 103.102 200.638 103.437 201.066 103.86C201.494 104.283 201.833 104.785 202.064 105.338C202.296 105.89 202.414 106.483 202.414 107.081V111.646Z",
    fill: "#7461F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.981 159.629H193.543C194.752 159.629 195.913 159.154 196.768 158.308C197.623 157.462 198.104 156.315 198.104 155.119C198.104 153.923 197.624 152.775 196.768 151.929C195.913 151.082 194.753 150.607 193.543 150.606C192.333 150.607 191.172 151.082 190.317 151.929C189.462 152.775 188.981 153.923 188.981 155.119V159.629Z",
    fill: "#7461F2"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.58 150.391C195.005 150.391 196.161 149.248 196.161 147.838C196.161 146.428 195.005 145.286 193.58 145.286C192.154 145.286 190.998 146.428 190.998 147.838C190.998 149.248 192.154 150.391 193.58 150.391Z",
    fill: "#7461F2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M131.128 101.693V99.3243H120.302V101.693H131.128Z",
    fill: "#7461F2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.669 105.243V102.874H120.305V105.243H134.669Z",
    fill: "#7461F2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M133.471 108.796V106.427H120.302V108.796H133.471Z",
    fill: "#7461F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M131.079 112.349V109.98H120.305V112.349H131.079Z",
    fill: "#7461F2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M65.6171 112.373V111.032H56.1311V112.373H65.6171Z",
    fill: "#7461F2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M49.742 99.7682L48.1688 101.324L54.5583 107.641L56.1315 106.086L49.742 99.7682Z",
    fill: "#7461F2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1309 106.232L54.5577 104.677L48.1683 110.994L49.7415 112.55L56.1309 106.232Z",
    fill: "#7461F2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M124.9 147.286C125.749 147.111 126.625 147.111 127.473 147.286C127.53 147.656 127.67 148.008 127.884 148.317C128.098 148.625 128.379 148.883 128.707 149.069C129.035 149.256 129.401 149.367 129.778 149.394C130.155 149.422 130.534 149.365 130.886 149.228C131.465 149.867 131.902 150.619 132.171 151.434C131.876 151.667 131.638 151.962 131.474 152.299C131.311 152.635 131.226 153.003 131.226 153.376C131.226 153.749 131.311 154.118 131.474 154.454C131.638 154.79 131.876 155.086 132.171 155.318C131.897 156.131 131.459 156.881 130.883 157.521C130.531 157.384 130.152 157.328 129.775 157.355C129.398 157.383 129.032 157.494 128.704 157.68C128.376 157.867 128.095 158.124 127.881 158.433C127.667 158.741 127.527 159.094 127.47 159.464C126.621 159.638 125.746 159.638 124.897 159.464C124.841 159.093 124.7 158.741 124.487 158.432C124.273 158.123 123.992 157.865 123.664 157.679C123.336 157.492 122.97 157.381 122.592 157.354C122.215 157.327 121.836 157.384 121.484 157.521C120.907 156.882 120.47 156.132 120.199 155.318C120.494 155.085 120.731 154.789 120.895 154.453C121.058 154.116 121.143 153.748 121.143 153.375C121.143 153.002 121.058 152.633 120.895 152.297C120.731 151.96 120.494 151.664 120.199 151.431C120.335 151.026 120.512 150.635 120.727 150.265C120.943 149.895 121.196 149.547 121.484 149.228C121.836 149.366 122.215 149.423 122.592 149.396C122.97 149.368 123.336 149.257 123.664 149.071C123.992 148.884 124.273 148.627 124.487 148.318C124.7 148.009 124.841 147.656 124.897 147.286H124.9ZM126.188 155.242C126.561 155.242 126.926 155.132 127.236 154.927C127.547 154.722 127.788 154.431 127.931 154.09C128.074 153.749 128.111 153.374 128.038 153.012C127.966 152.65 127.786 152.318 127.522 152.057C127.258 151.796 126.922 151.619 126.556 151.547C126.19 151.475 125.811 151.512 125.466 151.653C125.121 151.794 124.827 152.033 124.62 152.34C124.412 152.647 124.301 153.007 124.301 153.376C124.301 153.621 124.35 153.864 124.445 154.09C124.54 154.316 124.679 154.522 124.854 154.695C125.029 154.869 125.237 155.006 125.466 155.1C125.695 155.193 125.94 155.242 126.188 155.242Z",
    fill: "#7461F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8985 158.347C50.8152 157.275 50.1414 155.864 49.9918 154.356C49.8422 152.848 50.2261 151.335 51.078 150.075C51.93 148.816 53.1975 147.887 54.6643 147.448C56.1311 147.008 57.7065 147.085 59.1223 147.666C60.5381 148.246 61.7065 149.294 62.4287 150.63C63.1508 151.967 63.3819 153.51 63.0826 154.996C62.7832 156.482 61.9719 157.82 60.787 158.781C59.602 159.742 58.1167 160.268 56.5841 160.267H49.9591L51.8985 158.347ZM55.9324 149.786V157.647H57.2574V149.777L55.9324 149.786ZM53.2824 151.75V155.68H54.6074V151.75H53.2824ZM58.5824 151.75V155.68H59.9074V151.75H58.5824Z",
    fill: "#7461F2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M220.756 182.843H168.585C166.499 182.843 164.808 184.515 164.808 186.577V216.581C164.808 218.643 166.499 220.315 168.585 220.315H220.756C222.842 220.315 224.532 218.643 224.532 216.581V186.577C224.532 184.515 222.842 182.843 220.756 182.843Z",
    fill: "#E3E5F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M220.756 182.843H168.585C166.499 182.843 164.808 184.515 164.808 186.577V216.581C164.808 218.643 166.499 220.315 168.585 220.315H220.756C222.842 220.315 224.532 218.643 224.532 216.581V186.577C224.532 184.515 222.842 182.843 220.756 182.843Z",
    stroke: "url(#paint17_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9816 182.843H30.8103C28.7247 182.843 27.0339 184.515 27.0339 186.577V216.581C27.0339 218.643 28.7247 220.315 30.8103 220.315H82.9816C85.0672 220.315 86.758 218.643 86.758 216.581V186.577C86.758 184.515 85.0672 182.843 82.9816 182.843Z",
    fill: "#E3E5F0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9816 182.843H30.8103C28.7247 182.843 27.0339 184.515 27.0339 186.577V216.581C27.0339 218.643 28.7247 220.315 30.8103 220.315H82.9816C85.0672 220.315 86.758 218.643 86.758 216.581V186.577C86.758 184.515 85.0672 182.843 82.9816 182.843Z",
    stroke: "url(#paint18_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M51.309 196.058H62.4799C62.6445 196.058 62.8023 196.122 62.9187 196.237C63.035 196.352 63.1005 196.509 63.1005 196.671V206.489C63.1005 206.652 63.035 206.808 62.9187 206.923C62.8023 207.038 62.6445 207.103 62.4799 207.103H51.309C51.1444 207.103 50.9866 207.038 50.8702 206.923C50.7538 206.808 50.6884 206.652 50.6884 206.489V196.671C50.6884 196.509 50.7538 196.352 50.8702 196.237C50.9866 196.122 51.1444 196.058 51.309 196.058ZM56.8944 203.421V204.649H60.6181V203.421H56.8944ZM54.6696 201.58L52.9132 203.314L53.7914 204.182L56.4259 201.58L53.7914 198.975L52.9132 199.844L54.6696 201.58Z",
    fill: "#7461F2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M152.179 182.843H100.008C97.9222 182.843 96.2314 184.515 96.2314 186.577V216.581C96.2314 218.643 97.9222 220.315 100.008 220.315H152.179C154.265 220.315 155.955 218.643 155.955 216.581V186.577C155.955 184.515 154.265 182.843 152.179 182.843Z",
    fill: "#E3E5F0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M152.179 182.843H100.008C97.9222 182.843 96.2314 184.515 96.2314 186.577V216.581C96.2314 218.643 97.9222 220.315 100.008 220.315H152.179C154.265 220.315 155.955 218.643 155.955 216.581V186.577C155.955 184.515 154.265 182.843 152.179 182.843Z",
    stroke: "url(#paint19_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M120.497 199.273C120.489 198.713 120.616 198.158 120.866 197.656C121.116 197.153 121.483 196.716 121.937 196.38C122.083 196.266 122.219 196.14 122.362 196.021C122.438 195.942 122.53 195.879 122.632 195.837C122.733 195.794 122.843 195.772 122.953 195.772C123.064 195.772 123.173 195.794 123.274 195.837C123.376 195.879 123.468 195.942 123.544 196.021C123.672 196.124 123.784 196.244 123.879 196.377C124.19 196.828 124.481 197.297 124.754 197.748C124.843 197.923 124.903 198.11 124.931 198.304C124.966 198.483 124.952 198.668 124.888 198.839C124.825 199.011 124.715 199.162 124.571 199.276C124.35 199.473 124.118 199.658 123.876 199.832C123.68 199.939 123.53 200.114 123.454 200.322C123.377 200.531 123.38 200.76 123.46 200.967C123.596 201.375 123.807 201.756 124.081 202.09C124.6 202.809 125.228 203.444 125.943 203.974C126.169 204.128 126.415 204.251 126.675 204.339C126.833 204.395 127.004 204.404 127.167 204.364C127.329 204.325 127.477 204.239 127.591 204.118C127.802 203.924 128.009 203.725 128.227 203.538C128.412 203.343 128.661 203.219 128.929 203.185C129.197 203.152 129.469 203.211 129.698 203.354C130.046 203.557 130.375 203.79 130.681 204.05C130.947 204.27 131.199 204.506 131.435 204.756C131.515 204.848 131.58 204.951 131.628 205.063C131.703 205.193 131.732 205.346 131.709 205.494C131.686 205.643 131.612 205.78 131.5 205.882C131.133 206.274 130.716 206.617 130.259 206.904C129.807 207.157 129.309 207.318 128.793 207.378C128.277 207.438 127.755 207.396 127.255 207.253C126.374 207.018 125.553 206.6 124.848 206.026C123.388 204.914 122.171 203.523 121.267 201.936C120.876 201.263 120.624 200.519 120.528 199.749C120.528 199.718 120.528 199.687 120.528 199.657C120.509 199.543 120.506 199.417 120.497 199.273Z",
    fill: "#7461F2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M199.621 200.132V196.533C199.622 196.455 199.607 196.378 199.577 196.306C199.547 196.234 199.502 196.169 199.447 196.114C199.391 196.059 199.325 196.015 199.252 195.985C199.179 195.956 199.101 195.941 199.022 195.941H198.42C197.235 197.113 195.007 197.782 193.62 198.089V204.483C195.001 204.79 197.235 205.452 198.42 206.631H199.022C199.101 206.631 199.179 206.616 199.252 206.586C199.325 206.557 199.391 206.513 199.447 206.458C199.502 206.403 199.547 206.338 199.577 206.265C199.607 206.193 199.622 206.116 199.621 206.038V202.433C199.88 202.368 200.109 202.22 200.273 202.011C200.437 201.803 200.525 201.547 200.525 201.283C200.525 201.019 200.437 200.763 200.273 200.554C200.109 200.346 199.88 200.197 199.621 200.132ZM190.017 198.316C189.86 198.315 189.704 198.346 189.558 198.405C189.412 198.464 189.28 198.552 189.168 198.662C189.057 198.772 188.968 198.902 188.908 199.046C188.848 199.19 188.817 199.344 188.817 199.5V203.062C188.817 203.377 188.943 203.679 189.168 203.902C189.394 204.125 189.699 204.25 190.017 204.25H190.616L191.218 207.22H192.419V198.322L190.017 198.316Z",
    fill: "#7461F2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M219.053 39.1696H82.9413C80.8557 39.1696 79.1649 40.8414 79.1649 42.9036V54.4583C79.1649 56.5205 80.8557 58.1923 82.9413 58.1923H219.053C221.138 58.1923 222.829 56.5205 222.829 54.4583V42.9036C222.829 40.8414 221.138 39.1696 219.053 39.1696Z",
    fill: "#E3E5F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M219.053 39.1696H82.9413C80.8557 39.1696 79.1649 40.8414 79.1649 42.9036V54.4583C79.1649 56.5205 80.8557 58.1923 82.9413 58.1923H219.053C221.138 58.1923 222.829 56.5205 222.829 54.4583V42.9036C222.829 40.8414 221.138 39.1696 219.053 39.1696Z",
    stroke: "url(#paint20_linear_157_1102)",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3487 53.4269L38.5389 56.4282V40.5638C38.5389 40.0902 38.9219 39.7063 39.3942 39.7063H54.7889C55.2613 39.7063 55.6442 40.0902 55.6442 40.5638V52.5693C55.6442 53.0429 55.2613 53.4269 54.7889 53.4269H42.3487ZM43.7945 47.485L42.9605 47.9678L43.8158 49.453L44.6505 48.9698C45.0795 49.4079 45.6249 49.7309 46.2363 49.8887V50.8543H47.9468V49.8887C48.5582 49.7309 49.1035 49.4079 49.5325 48.9698L50.3673 49.453L51.2225 47.9678L50.3886 47.485C50.4694 47.1927 50.5126 46.8847 50.5126 46.5666C50.5126 46.2484 50.4694 45.9405 50.3886 45.6482L51.2225 45.1654L50.3673 43.6801L49.5325 44.1633C49.1035 43.7253 48.5582 43.4023 47.9468 43.2445V42.2789H46.2363V43.2445C45.6249 43.4023 45.0795 43.7253 44.6505 44.1633L43.8158 43.6801L42.9605 45.1654L43.7945 45.6482C43.7137 45.9405 43.6705 46.2484 43.6705 46.5666C43.6705 46.8847 43.7137 47.1927 43.7945 47.485ZM47.0915 48.2817C46.1468 48.2817 45.381 47.5138 45.381 46.5666C45.381 45.6194 46.1468 44.8515 47.0915 44.8515C48.0363 44.8515 48.8021 45.6194 48.8021 46.5666C48.8021 47.5138 48.0363 48.2817 47.0915 48.2817Z",
    fill: "#DDD8FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M171.42 420.965L168.874 422.971V412.369C168.874 412.052 169.13 411.796 169.445 411.796H179.733C180.049 411.796 180.305 412.052 180.305 412.369V420.392C180.305 420.709 180.049 420.965 179.733 420.965H171.42ZM172.386 416.994L171.829 417.317L172.4 418.309L172.958 417.987C173.245 418.279 173.609 418.495 174.018 418.601V419.246H175.161V418.601C175.569 418.495 175.934 418.279 176.22 417.987L176.778 418.309L177.35 417.317L176.793 416.994C176.847 416.799 176.875 416.593 176.875 416.381C176.875 416.168 176.847 415.962 176.793 415.767L177.35 415.444L176.778 414.452L176.22 414.774C175.934 414.482 175.569 414.266 175.161 414.16V413.515H174.018V414.16C173.609 414.266 173.245 414.482 172.958 414.774L172.4 414.452L171.829 415.444L172.386 415.767C172.332 415.962 172.303 416.168 172.303 416.381C172.303 416.593 172.332 416.799 172.386 416.994ZM174.589 417.527C173.958 417.527 173.446 417.014 173.446 416.381C173.446 415.748 173.958 415.234 174.589 415.234C175.221 415.234 175.732 415.748 175.732 416.381C175.732 417.014 175.221 417.527 174.589 417.527Z",
    fill: "#ABA6FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_1102",
    x1: -16.1478,
    y1: -19.678,
    x2: 246.366,
    y2: 449.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBEB",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CDCFE6",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C6C7E2",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C3C4E1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_157_1102",
    x1: 128.5,
    y1: 0.81432,
    x2: 128.5,
    y2: 465.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C3C4E1",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_157_1102",
    x1: 130.849,
    y1: 515.697,
    x2: 128.804,
    y2: 268.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E2E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_157_1102",
    x1: 155.602,
    y1: 434.304,
    x2: 7.63573,
    y2: 306.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#242243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2D2B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#383669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#43427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_157_1102",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_157_1102",
    x1: 205.753,
    y1: 379.243,
    x2: 199.54,
    y2: 256.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E2E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_157_1102",
    x1: 229.41,
    y1: 6.81876,
    x2: -44.7752,
    y2: 352.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D8DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D6D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C0C3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ADB0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9B9EC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_157_1102",
    x1: -15.4092,
    y1: 328.873,
    x2: 232.376,
    y2: 219.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#D8DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D8DBEB",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D9DCEC",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DBDEED",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#DEE1EE",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#E2E4F0",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E7E8F2",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ECEEF5",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F2F3F9",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F9FAFC",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_157_1102",
    x1: 185.146,
    y1: 329.839,
    x2: 185.146,
    y2: 396.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_157_1102",
    x1: 198.464,
    y1: 399.113,
    x2: 198.464,
    y2: 417.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_157_1102",
    x1: 136.934,
    y1: 377.393,
    x2: 40.0108,
    y2: 377.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#5C5CA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7A78C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#928EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A39EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ADA7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B0AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_157_1102",
    x1: 194.669,
    y1: 87.4259,
    x2: 194.669,
    y2: 124.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_157_1102",
    x1: 126.092,
    y1: 87.4259,
    x2: 126.092,
    y2: 124.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_157_1102",
    x1: 56.8944,
    y1: 87.4259,
    x2: 56.8944,
    y2: 124.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_157_1102",
    x1: 194.359,
    y1: 134.983,
    x2: 194.359,
    y2: 172.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_157_1102",
    x1: 125.782,
    y1: 134.983,
    x2: 125.782,
    y2: 172.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_157_1102",
    x1: 56.5841,
    y1: 134.983,
    x2: 56.5841,
    y2: 172.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_157_1102",
    x1: 194.669,
    y1: 182.846,
    x2: 194.669,
    y2: 220.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_157_1102",
    x1: 56.8944,
    y1: 182.846,
    x2: 56.8944,
    y2: 220.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_157_1102",
    x1: 126.092,
    y1: 182.846,
    x2: 126.092,
    y2: 220.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_157_1102",
    x1: 150.994,
    y1: 39.1696,
    x2: 150.994,
    y2: 58.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedServices);
export default __webpack_public_path__ + "static/media/Managed-Services.f05f59eec4ebafe4a64a813243c85ec6.svg";
export { ForwardRef as ReactComponent };